import { HttpContextToken } from '@angular/common/http';

/**
 * HttpContext tokens used to thread tracking metadata onto outgoing requests
 * (PRODSUPP-145765). Kept in their own module so the TrackingService and the
 * logging interceptor can share them without a circular import.
 */

/**
 * When set to `true`, the logging interceptor skips the request. Used on the
 * tracking ingest POST itself to avoid an infinite logging loop.
 */
export const SKIP_TRACKING = new HttpContextToken<boolean>(() => false);

/**
 * Carries the correlation id that links a user action to the API call(s) it
 * triggers. Empty string means "no correlation id supplied"; the interceptor
 * falls back to a generated id so every api_call still has one.
 */
export const CORRELATION_ID = new HttpContextToken<string>(() => '');

/** Generates a correlation id, preferring crypto.randomUUID when available. */
export function generateCorrelationId(): string {
    try {
        if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
            return crypto.randomUUID();
        }
    } catch {
        // fall through to the manual generator
    }
    return `cid-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
